import React from 'react';
import { Typography } from '@mui/material';

interface FormFieldErrorProps {
  error?: string;
  fieldId: string;
  visible?: boolean;
}

/**
 * FormFieldError component displays validation error messages for form fields
 * with proper accessibility attributes.
 * 
 * Features:
 * - Displays error message with consistent styling
 * - Includes ARIA attributes for screen reader support
 * - Conditionally renders based on error presence
 * 
 * @param error - The error message to display
 * @param fieldId - The ID of the associated form field
 * @param visible - Whether to show the error (default: true)
 */
export const FormFieldError: React.FC<FormFieldErrorProps> = ({
  error,
  fieldId,
  visible = true,
}) => {
  if (!error || !visible) return null;

  return (
    <Typography
      id={`${fieldId}-error`}
      variant="caption"
      color="error"
      sx={{ display: 'block', mt: 0.5 }}
      role="alert"
      aria-live="polite"
    >
      {error}
    </Typography>
  );
};
